import { GzPushBodyLayoutWebComponent } from './component/GzPushBodyLayoutWebComponent';
import { WEB_COMPONENT_GZ_PUSH_BODY_LAYOUT } from '../../webcomponents.constants';

export { GzPushBodyLayoutWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_PUSH_BODY_LAYOUT, GzPushBodyLayoutWebComponent);
